import { createContext, useState } from 'react';
import theme, {createThemedBorders, UwKluisTheming} from '../theme';
import {tenants} from '../utils/constants';
import Color from 'color';

const WhiteLabelContext = createContext();

export const WhiteLabelProvider = ({ children, defaultState }) => {
  const [whiteLabel, setWhiteLabel] = useState(defaultState || {});
  const colorScheme = { ...UwKluisTheming, ...whiteLabel.colorScheme };
  const themedBorders = createThemedBorders(colorScheme);

  const Logo = (props) => (
    <img
      src={whiteLabel.files?.logo}
      alt={'Bedrijfslogo'}
      css={{
        display: 'block',
        height: '80px',
        width: '100%',
        maxWidth: '224px',
        objectFit: 'contain',
        objectPosition: 'center',
      }}
      {...props}
    />
  );

  // Tenants
  const isRedLabel = whiteLabel?.id === tenants.DEFAULT;
  const isTenant = whiteLabel?.id !== tenants.DEFAULT;
  const isArgo = whiteLabel?.id === 'argo-aflosvrij-demo';
  const isNN = whiteLabel?.id === 'nn';

  const customArgoStyling = {
    font: 'ABC Repro',
    usesArgoIcons: true,
    borderRadius: '34px',
    cardStyleOverwrite:  {
      borderRadius: {
        mobile: 24, desktop: 32
      },
      border: 0,
      boxShadow: "0 0 24px 0 rgba(0, 0, 0, 0.12)",
    }
  }

  const customNnStyling = {
    font: 'Nitti Grotesk'
  }

  const primaryContrast = Color(colorScheme.primaryActive).isLight() ? colorScheme.primaryFont : colorScheme?.white;

  const currentTheme = {
    ...theme,
    ...(isTenant && {
      colors: {
        ...colorScheme,
        ...{ primaryContrast },
      },
      borders: themedBorders,
      ...(isArgo ? customArgoStyling : {}),
      ...(isNN ? customNnStyling : {}),
    })
  };

  return (
    <WhiteLabelContext.Provider
      value={{
        ...whiteLabel,
        isRedLabel,
        isTenant,
        isArgo,
        Logo,
        currentTheme,
        setWhiteLabel,
      }}
    >
      {children}
    </WhiteLabelContext.Provider>
  );
};

export const WhiteLabelConsumer = WhiteLabelContext.Consumer;

export default WhiteLabelContext;
